/* @ngInject */
function LoginController (
  $scope,
  $rootScope,
  $translate,
  $timeout,
  $state,
  $stateParams,
  $location,
  $cookies,
  BackendErrorParserService,
  InitializerService,
  AuthService,
  MessageService,
  ToastService,
  SegmentService,
  Utils,
  RequestDeduplicationService
) {
  const sHost = $location.host()
  $scope.subdomain = ''
  $scope.customerLogoPath = ''
  $scope.backgroundUrl = ''
  $scope.backgroundImageUrl = ''
  $scope.userLogin = {
    email: $stateParams.email,
    password: ''
  }
  $scope.showPassword = false
  $scope.flags = {
    loadingLogo: true,
    loadingBackground: true,
    showBanner: $location.search().showBanner === 'true'
  }

  $scope.loginBtnLoading = false

  const api = { activate, _sendJwtToMobile, loginSuccess, authMobile, showLoginError, _addEventListenerToInputs }

  this.getApi = () => api

  activate()

  function activate () {
    RequestDeduplicationService.clearCache()
    AuthService.setContainerPosition()

    AuthService.getCustomerImages(sHost).then(url => {
      const setCustomerImages = () => {
        $scope.customerLogoPath = url.logo
        $scope.backgroundUrl = url.background
      }
      $scope.subdomain = localStorage.getItem('companySubdomain')

      const skipSsoValidation = $stateParams.skipSsoValidation
      if ($scope.subdomain && !skipSsoValidation) {
        AuthService.getCompanyBySubdomain($scope.subdomain)
          .then(company => {
            if (company.hasSSO) {
              const params = $location.search()
              const next = params?.next
              const userEmail = params.userEmail || next?.split('&userEmail=')[1]

              $state.go('loginSso', {
                next,
                userEmail
              })
            } else {
              setCustomerImages()
            }
          })
          .catch(() => {
            setCustomerImages()
          })
      } else {
        setCustomerImages()
      }
    })

    api._addEventListenerToInputs()
  }

  function _sendJwtToMobile () {
    const isInCordovaWebView = Utils.isInCordovaWebView()
    const isInReactNativeWebView = Utils.isInReactNativeWebView()

    if (isInCordovaWebView || isInReactNativeWebView) {
      const jwt = $cookies.get('jwt')
      if (jwt) {
        if (isInCordovaWebView) {
          window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({ jwt, type: 'JWT_TOKEN' }))
        } else if (isInReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ jwt, type: 'JWT_TOKEN' }))
        }
      }
    }
  }

  function authMobile () {
    AuthService.loginMobile($scope.userLogin)
      .then(loginSuccess, showLoginError)
      .finally(() => {
        $scope.loginBtnLoading = false
      })
  }

  function showLoginError (error) {
    if (!error) {
      return
    }

    if (BackendErrorParserService.isRateLimitError(error)) {
      const retryAfterHeader = error.headers('retry-after')

      if (retryAfterHeader) {
        const retryAfterMinutes = Utils.convertSecondsToMinutes(retryAfterHeader)
        const toastText = $translate.instant('tooManyRequests', { retryAfterMinutes })

        ToastService.showErrorToast(toastText)
        return
      }
    }

    if (BackendErrorParserService.isUserInactiveError(error)) {
      $state.go('inactive', { isPending: false })
    } else if (BackendErrorParserService.isUserPendingError(error)) {
      $state.go('inactive', { isPending: true })
    } else if (BackendErrorParserService.isBlockLoginsError(error)) {
      $state.go('blockLogins', { supportEmail: error.data.data.supportEmail })
    } else if (BackendErrorParserService.isWrongPasswordOrEmail(error)) {
      $scope.isWrongPasswordOrEmail = true
    } else if (BackendErrorParserService.shouldLoginWithSSO(error)) {
      MessageService.warning({
        title: $translate.instant('oopsTitle'),
        text: $translate.instant('warningLoginWithSso', { optText: $translate.instant('loginSso') }),
        confirmButtonText: 'ok',
        press: () => {
          $state.go('loginSso')
        }
      })
    } else if (BackendErrorParserService.shouldLoginWithMFA(error)) {
      $state.go('twoFactorVerification', {
        token: error.data.data.token,
        email: $scope.userLogin.email,
        password: $scope.userLogin.password
      })
    } else if (BackendErrorParserService.shouldHaveStrongPassword(error)) {
      $state.go('updatePassword', {
        token: error.data.data.token,
        oldPassword: $scope.userLogin.password,
        username: error.data.data.username,
        type: 'strength'
      })
    } else if (BackendErrorParserService.isPasswordExpired(error)) {
      $state.go('updatePassword', {
        token: error.data.data.token,
        oldPassword: $scope.userLogin.password,
        username: error.data.data.username,
        type: 'expiration'
      })
    } else {
      ToastService.defaultErrorToast()
    }
  }

  function loginSuccess () {
    $scope.userLogin = {}
    // para não executar a landing page ao navegar de tela
    if (!Utils.isInReactNativeWebView() && !$rootScope.isDesktop) {
      localStorage.setItem('landingPageFlowExecuted', 'true')
      $rootScope.landingPageFlowExecuted = true
    }

    return InitializerService.initApplication().then(() => {
      SegmentService.track('user-login', { id: $rootScope.oUser.id, sso_enabled: false })

      const isWorkflowPlan = $rootScope.companyFeaturesAndAddons?.pricingPackageId === 4
      if ($rootScope.oUser.onboarding_status === 'COMPANY') {
        $state.go('onboardingStepCompany')
      } else if ($rootScope.oUser.onboarding_status === 'MODULES') {
        $state.go('onboardingStepModules')
      } else if ($rootScope.oUser.onboarding_status === 'BRANDING') {
        $state.go(isWorkflowPlan ? 'onboardingStepBrandingWorkflow' : 'onboardingStepBranding')
      } else {
        const params = $location.search()
        if (params.next) {
          $location.url(params.next)
        } else {
          const getScreen = () => {
            if (isWorkflowPlan) return 'ia'
            return 'home'
          }
          const screen = getScreen()
          $state.go(screen)
        }

        _sendJwtToMobile()
      }
    })
  }

  function _addEventListenerToInputs () {
    const inputs = $('.auth-container .field input')

    $timeout(() => {
      inputs.on('keydown', e => {
        if (e.key === 'Enter') {
          $scope.login()
        }
      })
    })
  }

  $scope.login = function () {
    $scope.isWrongPasswordOrEmail = false

    if (!$scope.userLogin.email || !$scope.userLogin.password) {
      $scope.isWrongPasswordOrEmail = true
      return
    }

    $scope.loginBtnLoading = true
    if (Utils.isInCordovaWebView() || Utils.isInReactNativeWebView()) {
      authMobile()
      return
    }

    AuthService.login($scope.userLogin)
      .then(loginSuccess, showLoginError)
      .finally(() => {
        $scope.loginBtnLoading = false
      })
  }

  $scope.onLogoLoad = function () {
    $timeout(() => {
      $scope.flags.loadingLogo = false
    })
  }

  $scope.onBackgroundLoad = function () {
    $timeout(() => {
      $scope.backgroundImageUrl = $scope.backgroundUrl
      $scope.flags.loadingBackground = false
    })
  }

  $scope.togglePasswordVisibility = function () {
    $scope.showPassword = !$scope.showPassword

    const passwordInput = document.getElementById('password')
    passwordInput.type = $scope.showPassword ? 'text' : 'password'
  }

  $scope.closeBanner = function () {
    $scope.flags.showBanner = false
  }
}

export { LoginController }
